import Text from '../../canvas/text'
import { FONT_SIZE, OFFSET, TextAlign, TextBaseline } from '../../constants/common'
import ChartLayoutModel from '../../models/chart_layout'
import { assets, getFormattedDateString } from '../../website-shared'

export const LOGO_BAR_HEIGHT = 22

export async function renderLogoAndDate({
  canvasContext,
  chartLayoutModel,
  width,
}: {
  canvasContext: CanvasRenderingContext2D
  chartLayoutModel: ChartLayoutModel
  width: number
}) {
  const pane = chartLayoutModel.charts().first().panes().first()
  const img = new Image()
  img.src = assets.logo
  await img.decode()
  canvasContext.drawImage(img, OFFSET.M, OFFSET.XS)
  canvasContext.save()
  const dateString = getFormattedDateString()
  new Text(
    {
      text: dateString,
      x: width - OFFSET.M,
      y: LOGO_BAR_HEIGHT / 2,
      font: { size: FONT_SIZE.M, style: 'bold' },
      textBaseline: TextBaseline.middle,
      textAlign: TextAlign.right,
    },
    pane
  ).render(canvasContext)
  canvasContext.restore()
}
